import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { encryptionDetailLive } from "@/api/php/player";
import { storeToRefs } from "pinia"
import { serverConfigPiniaState } from "@/store/serverConfig";
import { toLocationBrowser } from "@/uitls/native";
import { useI18n } from 'vue-i18n'
interface dataProps {
  roomdata: any;
}

const __default__ = {
  name: "Basketball",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    roomdata: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  roomdata: any;
}

_useCssVars(_ctx => ({
  "4910b773-primaryColor": (_unref(primaryColor))
}))


const { t } = useI18n()
const ConfigpiniaStore = serverConfigPiniaState();
const { matchAD } = storeToRefs(ConfigpiniaStore);
const route = useRoute();
const th = process.env.VUE_APP_Language as string;

let data = ref();
let tlive = ref([]);
let incidents = ref([]);
let team1 = ref("");
let team2 = ref("");
let home_score = ref([]);
let allHomeScore = ref(0);
let away_score = ref([]);
let allAwayScore = ref(0);
let detailsshow = ref(true);
let basktextname = ref([1]);
let statsall = ref([]);



onMounted(() => {
  getData();
  teamname();
});

const getData = async () => {
  let { matchType, matchId } = route.query;

  if (
    matchId == "" ||
    matchId == null ||
    matchId == undefined ||
    matchId == "0"
  ) {
    if(props.roomdata.match_id){
      matchId = props.roomdata.match_id;
    }else{
       matchId = props.roomdata.id;
    }
  }
  if (
    matchType == "" ||
    matchType == null ||
    matchType == undefined ||
    matchType == "0"
  ) {
    if (props.roomdata.type_id) {
      matchType = props.roomdata.type_id
    } else {
      matchType = props.roomdata.match_type;
    }
  }

  if (
    matchType != "" &&
    matchType != null &&
    matchType != undefined &&
    matchId != "" &&
    matchId != null &&
    matchId != undefined
  ) {

    //   赛况数据
    const res: any = await encryptionDetailLive({
      type_id: matchType,
      match_id: matchId,
    });
    if (res.code == 200) {
      data.value = res.data;
      if (res.data && res.data.tlive) {
        // 文字直播
        let lives = [];
        let datass = [];
        for (let i = 0; i < res.data.tlive.length; i++) {
          if (res.data.tlive[i]) {
            lives = res.data.tlive[i].reverse();
          }
          let title = "第" + (i + 1) + "节";
          if (i >= 4) {
            title = t('match.matchjs');
          }
          let obj = {
            title: title,
            live: lives,
            open: i == res.data.tlive.length - 1,
          };
          datass.push(obj);
        }
        // 倒序输出
        tlive.value = datass.reverse();
      }
      if (res.data && res.data.players) {
        // 技术统计
        incidents.value = getRanking(res.data.players);
        // console.log(incidents.value, "技术统计");
      }

      statsall.value = res.data.stats;
      // console.log(statsall.value, "球队统计");

      renderAbstract();
    }
  }
};
const renderAbstract = () => {
  // 球队1得分
  home_score.value = data.value && data.value.score ? data.value.score[3] : [];
  allHomeScore.value = 0;
  if (home_score.value.length > 0) {
    for (let i = 0; i < home_score.value.length; i++) {
      allHomeScore.value += home_score.value[i];
    }
  }
  // 球队2得分
  away_score.value = data.value && data.value.score ? data.value.score[4] : [];
  allAwayScore.value = 0;
  if (away_score.value.length > 0) {
    for (let i = 0; i < away_score.value.length; i++) {
      allAwayScore.value += away_score.value[i];
    }
  }
};
const teamname = async () => {
  // 队伍名称1
  if (
    props.roomdata &&
    props.roomdata.home_name != "" &&
    props.roomdata.home_name != null &&
    props.roomdata.home_name != undefined
  ) {
    team1.value = props.roomdata.home_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team1.value = arr[0];
  }
  // 队伍名称2
  if (
    props.roomdata &&
    props.roomdata.away_name != "" &&
    props.roomdata.away_name != null &&
    props.roomdata.away_name != undefined
  ) {
    team2.value = props.roomdata.away_name;
  } else {
    let arr = props.roomdata.room_title.split("VS");
    team2.value = arr[1];
  }
};
const getItemsData = (item, idx) => {
  if (item) {
    let items = item.split("^");
    if (items[idx]) {
      return items[idx];
    }
  }
  return "";
};
const getRanking = (data) => {
  if (!data) return [];
  let homePlayers = [];
  let awayPlayers = [];
  if (data[0]) {
    for (let i = 0; i < data[0].length; i++) {
      homePlayers.push(data[0][i]);
    }
  }
  if (data[1]) {
    for (let i = 0; i < data[1].length; i++) {
      awayPlayers.push(data[1][i]);
    }
  }

  let result = [];
  result.push(putRanking({}, t('play.score'), 13, homePlayers, awayPlayers));
  result.push(putRanking({}, t('play.lb'), 6, homePlayers, awayPlayers));
  result.push(putRanking({}, t('match.matchzg1'), 7, homePlayers, awayPlayers));
  result.push(putRanking({}, t('match.matcqd'), 8, homePlayers, awayPlayers));
  result.push(putRanking({}, t('play.gm'), 9, homePlayers, awayPlayers));
  return result;
};

const putRanking = (item, title, index, homePlayers, awayPlayers) => {
  item.title = title;
  maxItem(item, index, homePlayers, awayPlayers);
  return item;
};

const maxItem = (obj, index, homePlayers, awayPlayers) => {
  let maxScore = -1;
  for (let i = 0; i < homePlayers.length; i++) {
    let item = homePlayers[i][6];
    if (item) {
      let items = item.split("^");
      if (items && items[1] && items[index]) {
        if (Number(items[index]) > maxScore) {
          obj.homeName = homePlayers[i][1];
          obj.homeScore = items[index];
          maxScore = Number(items[index]);
        }
      }
    }
  }

  maxScore = -1;
  for (let i = 0; i < awayPlayers.length; i++) {
    let item = awayPlayers[i][6];
    if (item) {
      let items = item.split("^");
      if (items && items[1] && items[index]) {
        if (Number(items[index]) > maxScore) {
          obj.awayName = awayPlayers[i][1];
          obj.awayScore = items[index];
          maxScore = Number(items[index]);
        }
      }
    }
  }
};
const getPercent = (score1, score2) => {
  // 计算两个整数之间的百分比
  let lv = score1 + score2 == 0 ? 0 : (score2 / (score1 + score2)) * 100;
  return lv;
};
const getType = (type) => {
  const BASKETDATA = [
    "",
    t('match.matchsfqrqs'),
    t('match.matchefqrqs'),
    t('match.matchfqjqs'),
    t('match.matchsyzts'),
    t('match.matchfgs'),
    t('match.matchfqmzl'),
    t('match.matchzzts'),
  ];
  return BASKETDATA[type] ? BASKETDATA[type] : "";
};
const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;

const __returned__ = { t, ConfigpiniaStore, matchAD, route, th, data, tlive, incidents, team1, team2, home_score, allHomeScore, away_score, allAwayScore, detailsshow, basktextname, statsall, props, getData, renderAbstract, teamname, getItemsData, getRanking, putRanking, maxItem, getPercent, getType, primaryColor, toLocationBrowser }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})